import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import RenderField from './RenderField';
import Header from './Header.js';

class CheckTransmitterForm extends Component {
    constructor(props){
        super(props);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (

             <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FormattedHTMLMessage id="app.step_check_transmitter" description="Fields Generic"/>
                    </Header>
                     <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                         <form onSubmit={handleSubmit(this.props.saveCheck)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="check_transmitter" autoComplete="off" component={RenderField} type="cuil" label="Cuil del emisor del cheque" placeholder='Cuil del emisor del cheque'/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <Field className="form-control" name="check_recipient" autoComplete="off" component={RenderField} type="cuil" label="Cuil del beneficiario final" placeholder='Cuil del beneficiario final'/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Simular</button>
                                </div>
                            </div>
                        </form>
                          <SaveStepButton/>
                    </div>
                </div>
            </Section>
        );
    }
}

CheckTransmitterForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

CheckTransmitterForm = TopScrolleable(CheckTransmitterForm);
let validate = generateValidator([{name: 'check_transmitter', required: true}]);

CheckTransmitterForm = reduxForm({
    form: 'CheckTransmitterForm', // a unique name for this form
    validate
})(CheckTransmitterForm);

CheckTransmitterForm = withAuthControl(CheckTransmitterForm);

export default CheckTransmitterForm;



/** WEBPACK FOOTER **
 ** ./src/components/CheckTransmitterForm.js
 **/